<div class="as-snackbar-content">
  @if (data.icon) { @if(data.text === 'AUTH.instructionSend'){
  <mat-icon svgIcon="ic-circle-check-white"></mat-icon>
  }@else{
  <mat-icon svgIcon="ic-info-outline"></mat-icon>
  } }
  <span class="as-font as-font-16 as-open-sans as-font-bold">
    {{ data.text | translate }}
  </span>

  @if (data.dismiss) {
  <span matSnackBarActions>
    <button
      mat-button
      matSnackBarAction
      (click)="snackBarRef.dismissWithAction()"
    >
      {{ data.confirmMessage | translate }}
    </button>
  </span>
  }
</div>
